import { FC, PropsWithChildren } from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import { FormProvider, useForm } from 'react-hook-form';
import { z } from 'zod';
import { SAML_DOMAIN, SAML_METADATA, USERNAME_PASSWORD, GOOGLE_SIGNIN, SSO } from '../constants';
import { useAuthenticationQueryContext } from './AuthenticationQueryContext';

const schema = z.object({
  [USERNAME_PASSWORD]: z.boolean(),
  [GOOGLE_SIGNIN]: z.boolean(),
  [SSO]: z.boolean(),
  [SAML_DOMAIN]: z.string().optional(),
  [SAML_METADATA]: z.string().optional(),
});

type AuthenticationPolicyFormStateValues = z.infer<typeof schema>;

export const AuthenticationPolicyFormProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const { userPassAuthEnabled, googleAuthEnabled, samlAuthEnabled, samlDomain, samlMetadata } =
    useAuthenticationQueryContext();

  const defaultValues = {
    [USERNAME_PASSWORD]: userPassAuthEnabled,
    [GOOGLE_SIGNIN]: googleAuthEnabled,
    [SSO]: samlAuthEnabled,
    [SAML_DOMAIN]: samlDomain,
    [SAML_METADATA]: samlMetadata,
  };

  const methods = useForm<AuthenticationPolicyFormStateValues>({
    defaultValues,
    mode: 'onChange',
    resolver: zodResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
